export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceFunctionName: "スマホ連携機能",
      familyInfoSetting: {
        areaCode: "地域コード",
        maxLinkedSPCount: 3,
        serviceName: "サービス名設定",
        serviceProtocol: {
          fileName: "terms.pdf",
          contentType: "application/pdf",
          fileUri: "/pdf/img01.pdf",
          fileSize: 1024,
          thumbnailUri: "/images/img01.png"
        },
        loadingAnimationFile: {
          fileName: "loading.gif",
          contentType: "image/gif",
          fileUri: "/images/img01.gif",
          fileSize: 1024,
          thumbnailUri: "/images/img01.gif"
        },
        contact: "問い合わせ連絡先",
        departmentInCharge: "担当部署名",
        copyRight: "copyright",
        recommededLinkUrls: [
          {
            name: "app",
            dataSourceType: 2,
            parameters: "app://xxxxxxx"
          },
          {
            name: "PDF",
            dataSourceType: 1,
            pdfFile: {
              fileName: "link.pdf",
              contentType: "application/pdf",
              fileUri: "/pdf/img01.pdf",
              fileSize: 1024,
              thumbnailUri: "/images/img01.png"
            }
          }
        ]
      }
    }
  }
}